import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import SelectComponent from 'react-select';
import { uniqueId } from 'lodash';
import { pluck } from '../../helpers/pluck';
import InputLabel from '../atoms/labels/InputLabel';
import ErrorLabel from '../atoms/labels/ErrorLabel';
import SelectWrapper from '../atoms/SelectWrapper';
import ReactSelectRequiredFixed from './ReactSelectRequiredFixed';
const OuterWrapper = styled.div `
    position: relative;
    margin-bottom: 20px;
    margin-right: 20px;
    width: ${props => (props.width ? props.width : 'auto')};

    &:last-child {
        margin-right: 0;
    }

    &:first-child&:last-child {
        margin: 0;
    }
`;
const FilterSelectItem = ({ label, placeholder, error, name, value, defaultValue, options, width, setFilter, required = false, isMulti, }) => {
    const [fieldId] = useState(uniqueId);
    const onChange = (option) => {
        if (Array.isArray(option)) {
            setFilter(name, option.map(pluck('value')));
            return;
        }
        setFilter(name, option?.value || '');
        return;
    };
    const selectedOption = useMemo(() => {
        if (Array.isArray(value)) {
            return options.filter(({ value: v }) => value.includes(v));
        }
        return options.find(({ value: v }) => v === value);
    }, [options, value]);
    const hasActiveFilter = !!(value && value !== defaultValue);
    return (_jsxs(OuterWrapper, { width: width, children: [_jsx(InputLabel, { marginBottom: "6px", htmlFor: fieldId, activeFilter: hasActiveFilter, required: required, children: label }), _jsx(SelectWrapper, { activeFilter: hasActiveFilter, children: _jsx(ReactSelectRequiredFixed, { id: fieldId, options: options, className: "react-select-container", name: name, placeholder: placeholder, classNamePrefix: "react-select", onChange: onChange, value: selectedOption, default: defaultValue, required: required, SelectComponent: SelectComponent, isMulti: isMulti }) }), error && _jsx(ErrorLabel, { children: error })] }));
};
export default FilterSelectItem;
